export default {
  locked: {
    en: 'Outcome removed or suspended',
  },
  possibleWin: {
    en: 'Possible win',
  },
}
